import { AdditionalColorsType, ThemeInterface } from './types'

// NOTE: to set color for skeletons
export const initialTheme: ThemeInterface = {
  disabled: '#CBD5E1',
}

export const baseTheme: ThemeInterface = {
  background: '#fafafa',
  'block-background': '#ffffff',
  'header-background': '#ffffff',
  'header-text': '#18181b',
  primary: '#18181b',
  secondary: '#279fe7',
  disabled: '#e4e4e7',
}

export const additionalColors: AdditionalColorsType = {
  'hover-secondary': { baseColor: 'secondary', opacity: 0.8 },
  'hover-primary': { baseColor: 'primary', opacity: 0.8 },
  'hover-header-text': { baseColor: 'header-text', opacity: 0.8 },
}
